import React, { ReactElement } from 'react';
import { get } from 'lodash';
import { FastField as FormikField, FieldArray } from 'formik';
import { Field, Textarea, ActionItem } from '../../../../../gs-component-form';
import Icon from '@xo-union/tk-component-icons';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import { trackQuestionInteraction } from '../../../../helpers/analytics';
import { spaceBarPressed } from '../../../../helpers/utilities';
import Toast from '../../../Toast';
import { Values } from '../../../../EventTypes';
import styles from './styles.scss';

interface OptionFieldsProps {
  type: string;
  values: Values;
  isGeneralQuestion: boolean;
  displayInitialErrors: boolean;
}

const OptionFields: React.FC<OptionFieldsProps> = ({ values, type, displayInitialErrors, isGeneralQuestion }) => {
  const optionLabel = type === 'Meal' ? 'Meal Title*' : 'Option*';
  let { options } = values;
  options = options || [];
  const length = get(options, ['length']);

  return (
    <FieldArray
      name="options"
      render={(arrayHelpers: any): ReactElement => (
        <>
          {length < 2 && <Toast show type="Warning" message="You need to add at least two options for guests." />}
          {options?.map((option, idx) => (
            <>
              <FormRow>
                <FormColumn>
                  <Icon
                    className={styles.removeIcon}
                    data-testid="remove"
                    name="remove_circle"
                    size="md"
                    onClick={(): void => arrayHelpers.remove(idx)}
                    tabIndex={0}
                    onKeyDown={(e): void => spaceBarPressed(e) && arrayHelpers.remove(idx)}
                  />
                </FormColumn>
                <FormColumn xs md>
                  <FormikField
                    name={`options[${idx}].text`}
                    id="text-field"
                    displayInitialErrors={displayInitialErrors && option.text}
                  >
                    {(props: any): ReactElement => <Field label={optionLabel} data-testid="option.text" {...props} />}
                  </FormikField>
                </FormColumn>
              </FormRow>
              <FormRow>
                <FormColumn xs sm>
                  <div className={styles.descriptionContainer}>
                    <FormikField name={`options[${idx}].description`} id="description-field">
                      {(props: any): ReactElement => (
                        <Textarea label="Description" data-testid="description" {...props} />
                      )}
                    </FormikField>
                  </div>
                </FormColumn>
              </FormRow>
            </>
          ))}
          <ActionItem
            type="add"
            onClick={(): void => {
              arrayHelpers.push({ text: '', description: '' });
              trackQuestionInteraction({
                selection: 'add option',
                question: values,
                isGeneralQuestion,
              });
            }}
          >
            {length > 0 ? 'Add Another Option' : 'Add Option'}
          </ActionItem>
        </>
      )}
    />
  );
};

export default OptionFields;
